module.exports = __webpack_public_path__ + "static/media/photo-slide-3.15e408e6.jpg";